import EditableContainerBase from "Lib/Fs.SmartClient.Client/EditableContainerBase";
import { autoinject } from 'aurelia-framework';
import EditorVMBase from "Lib/Fs.SmartClient.Client/EditorVMBase";
import SortBy from "Lib/Fs.Core.Data/SortBy";
import PagingCriteria from "Lib/Fs.Core.Data/PagingCriteria";
import SortingCriteria from "Lib/Fs.Core.Data/SortingCriteria";
import CommonSearchVMBase from "Lib/Fs.SmartClient.Client/CommonSearchVMBase";

@autoinject
export default class SearchOnlyVMBase<T> extends CommonSearchVMBase {
    SearchResultCollectionView: T[] = [];
    SelectedItems: T[] = [];
    currentItem: T;
    ItemType: new () => T;
    IsSelectAllChecked: boolean;

    get CurrentItem() {
        return this.currentItem;
    }
    set CurrentItem(value: T) {
        if (!this.OnCurrentChanging(this, null))
            return;
        this.currentItem = value;
        this.OnCurrentChanged(this, null);
    }

    constructor(type: { new(): T; }) {
        super();
        this.ItemType = type;
        this.SortingCriteria = new Array<SortBy>();
        this.PagingCriteria = new PagingCriteria();
    }

    attached() {
        var self = this;
        this.bindingEngine.propertyObserver(this, 'PageSize')
            .subscribe((newValue, oldValue) => {
                if (newValue == oldValue)
                    return;

                if (self.EnablePaging && self.PageCount > 0) {
                    self.Search();
                }
            });
    }

    get PageCount() {
        if (this.PageSize == 0 || this.ItemCount == 0 || this.PageSize == null) return 0;
        var roundingValue = this.ItemCount / this.PageSize;
        var roundedValue = Math.round(roundingValue);
        return roundingValue > roundedValue ? roundedValue + 1 : roundedValue;
    }

    GetItemIndex(i: number) {
        return this.PageIndex * this.PageSize + i;
    }

    InitialPageIndexList() {
        var PageIndexList = [];
        for (var index = 1; index <= this.PageCount; index = index + 1)
            PageIndexList.push(index);

        this.GridPageIndexList = PageIndexList;
    }

    OnCurrentChanged(sender, e) {
        this.ClearChildNode();
        if (this.CurrentItem == null) return;

        this.AddChildNode(this.CurrentItem);
    };

    OnCurrentChanging(sender, e) {
        return true;
    };

    Search(isChangePage: boolean = false, isShowLoading: boolean = true) {
        var self = this;

        if (this.HasEditingChilds)
            return;

        this.SelectedItems = [];
        this.CurrentItem = null;
        this.IsSelectAllChecked = false;

        if (this.EnablePaging && this.PageSize > 0) {
            this.CountItems(function (count) {
                self.ItemCount = count;

                if ((self.EnablePaging && !isChangePage)) {
                    self.PageIndex = 0;
                }

                self.PagingCriteria = {
                    PageIndex: self.PageIndex,
                    PageSize: self.PageSize
                };

                self.SearchStep2(isChangePage, isShowLoading);
            }, isShowLoading);
        } else {
            self.SearchStep2(isChangePage, isShowLoading);
        }
    };

    SearchStep2(isChangePage: boolean = false, isShowLoading: boolean = true) {
        var self = this;

        if (this.SortingCriteria == null || this.SortingCriteria.length == 0)
            this.PrepareDefaultSortingCriteria(this.SortingCriteria);


        this.SearchItems(
            function (data) {
                self.PrepareListViewCollection(data);
                self.InitialPageIndexList();
                self.GeneratePageNumberList();
            }, this.SortingCriteria, this.PagingCriteria, isShowLoading);
    }

    PrepareDefaultSortingCriteria(sortingCriteria: SortingCriteria) {

    }

    CountItems(searchCallback: (result: number) => void, isShowLoading: boolean = true) {
        searchCallback(0);
    }

    SearchItems(searchCallback: (result: any[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria, isShowLoading: boolean = true) {

    }

    RemoveItems(items: T[]) {
        throw "This function has not yet been implemented.";
    };

    AddItems(items: T[]) {
        throw "This function has not yet been implemented.";
    };

    AddItem(item: T) {

    };

    RemoveItem(item: T) {

    };

    PrepareListViewCollection(list: T[]) {
        this.SearchResultCollectionView = [];

        if (list == null)
            return;

        var dataList = []
        for (var index = 0; index < list.length; index++) {
            var convertedData = list[index];

            dataList.push(convertedData);
        }
        this.SearchResultCollectionView = dataList;
    };

    SelectNewItem(editorVM: T) {
        this.CurrentItem = editorVM;
    }

    SortingChanged(column: string) {
        if (this.SortingCriteria.length > 0) {
            var sortingColumn = this.SortingCriteria.find(t => t.Name == column);
            if (sortingColumn == null) {
                this.SortingCriteria.pop();
                var sortBy = new SortBy();
                sortBy.Direction = 0;
                sortBy.Name = column;
                this.SortingCriteria.push(sortBy);
            } else {
                if (sortingColumn.Direction == 0) {
                    sortingColumn.Direction = 1;
                    sortingColumn.Name = column;
                } else if (sortingColumn.Direction == 1) {
                    sortingColumn.Direction = 0;
                    sortingColumn.Name = column;
                } else {
                    this.SortingCriteria.pop();
                }
            }
        } else {
            var sortBy = new SortBy();
            sortBy.Direction = 0;
            sortBy.Name = column;
            this.SortingCriteria.push(sortBy);
        }
        this.Search();
    }

    GetSortingStatus(column: string, var1: any) {
        var sortingColumn = this.SortingCriteria.find(t => t.Name == column);
        if (sortingColumn == null) {
            return -1;
        } else {
            return sortingColumn.Direction;
        }
    }

    SelectChanged(editorVM: T, isChecked: boolean) {
        if (isChecked) {
            this.SelectedItems.push(editorVM);
            if (this.SearchResultCollectionView.length == this.SelectedItems.filter(function (t) {
                return t['IsChecked'] == true
            }).length) {
                this.IsSelectAllChecked = true;
            }
        } else {
            for (var i = 0; i < this.SelectedItems.length; i++) {
                if (this.SelectedItems[i] === editorVM) {
                    this.SelectedItems.splice(i, 1);
                }
            }
            this.IsSelectAllChecked = false;
        }
    }

    public SelectAll(isChecked: boolean) {
        if (isChecked) {
            for (var i = 0; i < this.SearchResultCollectionView.length; i++) {
                var item = this.SearchResultCollectionView[i];
                this.SelectedItems.push(item);
                item['IsChecked'] = true;
            }
        } else {
            this.SelectedItems = [];
            for (var i = 0; i < this.SearchResultCollectionView.length; i++) {
                var item = this.SearchResultCollectionView[i];
                item['IsChecked'] = false;
            }
        }
    }
}
